'use strict';

module Patersons {

    export interface BankDetailsScope extends ng.IScope {
        directDebitForm: ng.IFormController;
        directCreditForm: ng.IFormController;
        parentController: AbstractController;
        accounts: Array<Account>;
        selectedAccount: Account;
        events: Patersons.BankDetailsViewCtrl;
        date: Date;
        isLoading: boolean;
        url: String;
        isSubmitted: boolean;
        submissionFailed: boolean;
        phoneNumberIsVerified: boolean;
        allApproversRegistered: boolean;
        submissionFailedVerifyPhoneNumber: boolean;
        submissionFailedNotAllApproversRegistered: boolean;
        hasApprovers: boolean;
        hasAcceptedTandCs: boolean;
        hasApplyAllChecked:boolean;
        disableCreditUpdate: boolean;
        isSensitive: boolean;
        scrollDuration: number;
        errorHandler: any;
        userCompany: UserCompany;
    }

    export class BankDetailsViewCtrl extends AccountBaseCtrl {
        scope: Patersons.BankDetailsScope;
        portfolioService: Patersons.PortfolioService;
        tokenService: Patersons.TokenService;
        identityService: Patersons.IdentityService;
        changeRequestService: Patersons.ChangeRequestService;
        modal: any;
        document: any;
        static $inject = ['$scope', '$uibModal', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$document', 'portfolioService', 'tokenService', 'changeRequestService', 'navigationService', 'identityService', 'userCompanyService'];

        constructor($scope, $uibModal, $log, $location, $window, $state, $stateParams, $http, $rootScope, $document, portfolioService, tokenService, changeRequestService, navigationService, identityService, userCompanyService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.portfolioService = portfolioService;
            this.tokenService = tokenService;
            this.changeRequestService = changeRequestService;
            this.identityService = identityService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isSubmitted = false;
            this.scope.submissionFailed = false;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.submissionFailedNotAllApproversRegistered = false;
            this.scope.phoneNumberIsVerified = false;
            this.scope.allApproversRegistered = false;
            this.scope.hasApprovers = false;

            this.scope.hasAcceptedTandCs = false;
            this.scope.hasApplyAllChecked = false;
            this.scope.disableCreditUpdate = false;

            var accountId = $stateParams.accountId;
            this.modal = $uibModal;
            this.document = $document;
            this.scope.scrollDuration = 700;
            this.scope.isSensitive = true;

            this.load()
            userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company;
              })
        }

        setSelectedAccount(accountId: string) {
            this.scope.hasApplyAllChecked = false;
            this.scope.hasAcceptedTandCs = false;
            this.scope.disableCreditUpdate = false;
            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];

            if (this.scope.selectedAccount) {
                this.scope.disableCreditUpdate = this.isCashManagementAccount(this.scope.selectedAccount.bankingDetails.creditBankAccount) &&
                    (!this.scope.selectedAccount.isChessManaged || this.scope.selectedAccount.bankingDetails.creditBankAccount.depositDividends);
            }

            this.scope.isSubmitted = false;
            this.scope.submissionFailed = false;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.submissionFailedNotAllApproversRegistered = false;

            this.checkAllApproversRegistered();
            this.checkHasApprovers();
        };

        private isCashManagementAccount(bankAccountDetail: BankAccountDetail) {
            return bankAccountDetail.serviceType === 'MM';
        }

        deselectDepositDividends() {
            if (this.scope.selectedAccount.isChessManaged) {
                this.scope.selectedAccount.bankingDetails.creditBankAccount.depositDividends = false;
            }
        }

        checkAllApproversRegistered() {
            if (!this.scope.selectedAccount) {
                return;
            }

            this.changeRequestService.areAllAccountApproversRegistered(this.scope.selectedAccount.accountId)
                .then((result : boolean) => {
                    this.scope.allApproversRegistered = result;
                },
                (reason) => { // error handling
                    this.scope.errorHandler = reason.data;
                });
        }

        checkHasApprovers() {
            if (!this.scope.selectedAccount) {
                return;
            }

            this.changeRequestService.getAccountApproversCount(this.scope.selectedAccount.accountId)
                .then((result: number) => {
                    this.scope.hasApprovers = result > 0;
                },
                (reason) => { // error handling
                    this.scope.errorHandler = reason.data;
                });
        }

        load() {
          this.identityService.getIsPhoneNumberVerifyed().
          then((phone_number_verified: boolean) => {
            this.scope.phoneNumberIsVerified = phone_number_verified;
            var promise = this.portfolioService.getCombinedPortfolioData();
            promise.then((result: Array<Account>) => {
                this.scope.accounts = result;
                if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {
                    this.setSelectedAccount(this.scope.accounts[0].accountId);
                }
            });
          });

          /*if (this.tokenService.tokenManager.profile.phone_number_verified === 'true') {
              this.scope.phoneNumberIsVerified = true;
          }
          var promise = this.portfolioService.getCombinedPortfolioData();
          promise.then((result: Array<Account>) => {
              this.scope.accounts = result;
              if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {
                  this.setSelectedAccount(this.scope.accounts[0].accountId);
              }
          });*/
        }

        canSubmitChangeRequest() {
            if (!this.scope.phoneNumberIsVerified) {
                this.scope.submissionFailedVerifyPhoneNumber = true;
            }

            if (!this.scope.allApproversRegistered) {
                this.scope.submissionFailedNotAllApproversRegistered = true;
            }

            if (this.scope.submissionFailedVerifyPhoneNumber || this.scope.submissionFailedNotAllApproversRegistered) {
                return false;
            }

            return true;
        };

        saveDirectDebitForm() {
            this.scope.selectedAccount.bankingDetails.debitBankAccount.cardType = "Debit Card";
            return this.saveForm(this.scope.directDebitForm, this.scope.selectedAccount, this.scope.selectedAccount.bankingDetails.debitBankAccount, false);
        }

        updatehasAcceptedTandCs(){
           if (!this.scope.hasApplyAllChecked) {
                this.scope.hasAcceptedTandCs = false;
            }
        };


        saveDirectCreditForm() {
          
            if(this.scope.hasApplyAllChecked && this.scope.hasAcceptedTandCs  ){
                 return this.saveForm(this.scope.directCreditForm, this.scope.selectedAccount, this.scope.selectedAccount.bankingDetails.creditBankAccount, true);

            }

            this.scope.selectedAccount.bankingDetails.creditBankAccount.cardType = "Credit Card";
            return this.saveForm(this.scope.directCreditForm, this.scope.selectedAccount, this.scope.selectedAccount.bankingDetails.creditBankAccount, false);
        }

        saveForm(form: ng.IFormController, account: Account, bankAccountDetail: BankAccountDetail, saveAll: boolean) {
            this.scope.submissionFailed = false;
            this.scope.isSensitive = true;

            if (form.$invalid || account == undefined) {
                return;
            }

            if (!this.canSubmitChangeRequest()) {
                var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
                return;
            }

            var modalPopup = this.modal.open({
                templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
                controller: BankDetailsChangeRequestCtrl,
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    account: account,
                    bankAccountDetail: bankAccountDetail,
                    saveAll: saveAll
                }
            });

            modalPopup.result
                .then((result) => {
                    if (result === true) {
                        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                        this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
                        this.scope.isSubmitted = true;
                    }
                    else {
                        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                        this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
                        this.scope.submissionFailed = true;
                    }
                },
                (reason) => { // error handling
                    this.scope.errorHandler = reason.data;
                });
        }
    }
}
